(function () {
  var drawer = document.getElementById('mn-drawer');
  var scrim  = document.getElementById('mn-scrim');
  var opener = document.getElementById('mn-hamburger');
  var closer = document.getElementById('mn-close');

  if (!drawer || !scrim || !opener || !closer) return;

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    scrim.setAttribute('aria-hidden', 'false');
    opener.setAttribute('aria-expanded', 'true');
    if (desktopShop) desktopShop.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closer.focus();
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    scrim.setAttribute('aria-hidden', 'true');
    opener.setAttribute('aria-expanded', 'false');
    if (desktopShop) desktopShop.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    opener.focus();
  }

  opener.addEventListener('click', open);
  closer.addEventListener('click', close);
  scrim.addEventListener('click', close);

  // Desktop "Shop" link also opens the drawer
  var desktopShop = document.getElementById('mn-desktop-shop-trigger');
  if (desktopShop) {
    desktopShop.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      close();
    }
  });

  // Focus trap
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
